export default __webpack_public_path__ + "static/WalkingAndBikingEncouragementPrograms-1a566f9518d306597f4b4631735bb81c.png";